import React, { MutableRefObject } from 'react';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';

import { StudioControlStyles } from '../styles';
import PrompterSettingsPanel from './PrompterSettingsPanel';
import PrompterControlsMobile from './PrompterControlsMobile';
import PrompterControlsDesktop from './PrompterControlsDesktop';

type Props = {
  refPrompter: MutableRefObject<HTMLDivElement | null>;
};

const PrompterControls = (
  { refPrompter }: Props
) => {
  const classes = StudioControlStyles();
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <>
      <Grid container className={classes.root} alignItems="center">
        {compact
          ? (
            <PrompterControlsMobile
              refPrompter={refPrompter}
            />
          )
          : (
            <PrompterControlsDesktop
              refPrompter={refPrompter}
            />
          )}
      </Grid>
      <PrompterSettingsPanel refPrompter={refPrompter} />
    </>
  );
};

export default PrompterControls;
